import { createCacheStore } from '@lib/utils/cache';
import { ShiftGeneratorTaskService } from '@api/ShiftGeneratorTaskService';

/*
 * ttlMs is zero because a task's runner status changes server-side on
 * its own: reads serve the last known status instantly, but always
 * revalidate in the background — the cache only saves the loading
 * flash, never freshness here.
 */

/** Cached ShiftGeneratorTaskService.getShiftGeneratorTask(departmentId, taskId, params?) reads. */
export const shiftGeneratorTaskCache = createCacheStore(
    'shiftGeneratorTask/task',
    ShiftGeneratorTaskService.getShiftGeneratorTask,
    { ttlMs: 0 },
);

/** Cached ShiftGeneratorTaskService.getShiftGeneratorTasks(departmentId) reads. */
export const shiftGeneratorTasksCache = createCacheStore(
    'shiftGeneratorTask/tasks',
    ShiftGeneratorTaskService.getShiftGeneratorTasks,
    { ttlMs: 0 },
);

/*
 * Drops all cached task data (after task mutations, full clears). The
 * cache keys embed the read params (includeTaskHolidays etc.), so
 * per-task invalidation cannot target every variant — mutations drop
 * the whole (ttl-0) cache instead.
 */
export const invalidateShiftGeneratorTaskData = (): void => {
    shiftGeneratorTaskCache.invalidateAll();
    shiftGeneratorTasksCache.invalidateAll();
};
